import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0b89b321&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=0b89b321&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89b321",
  null
  
)

export default component.exports